import { AppRouter } from 'routes/AppRouter';
import { NoSsr } from '@mui/material';
import { OverlaySpinner } from '@ankr.com/ui';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router';
import { QueryParamProvider } from 'use-query-params';
import { I18nextProvider } from 'react-i18next';
import { i18n } from '@ankr.com/common';

import { AppBase } from 'modules/layout/components/AppBase/AppBase';
import { Notifications } from 'domains/notifications/components/Notifications';
import { ScrollToTop } from 'modules/common/components/ScrollToTop';
import { RouteChangeListener } from 'modules/auth/components/RouteChangeListener';
import { Web3Provider } from 'modules/payments/components/Web3Provider';

import { persistor, store } from './store';
import { homepage } from '../package.json';
import { AuthProvider } from './modules/auth/components/AuthProvider/AuthProvider';
import { ReactRouter7Adapter } from './modules/router/components/ReactRouter7Adapter';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <Router basename={homepage}>
        <Provider store={store}>
          <PersistGate loading={<OverlaySpinner />} persistor={persistor}>
            <QueryParamProvider adapter={ReactRouter7Adapter}>
              <Web3Provider>
                <AuthProvider>
                  <AppBase>
                    <ScrollToTop />
                    <RouteChangeListener />
                    <AppRouter />
                    <NoSsr>
                      <Notifications />
                    </NoSsr>
                  </AppBase>
                </AuthProvider>
              </Web3Provider>
            </QueryParamProvider>
          </PersistGate>
        </Provider>
      </Router>
    </I18nextProvider>
  );
}

export default App;
